import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { AmbientMovement } from "@/components/AmbientMovement";
import { trackPage } from "@/lib/apiClient";

export function Layout({ children, page }) {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); if (page) trackPage(page); }, [pathname, page]);
  return (
    <div className="relative min-h-screen bg-ink-900 noise">
      <AmbientMovement />
      <Navbar />
      <main className="relative z-[2]">{children}</main>
      <Footer />
    </div>
  );
}

export default Layout;
